<template>
  <v-carousel height="auto" cycle show-arrows-on-hover hide-delimiter-background>
    <v-carousel-item v-for="(slide, i) in $vuetify.breakpoint.smAndDown ? slides.mobile_images:slides.desktop_images" :key="i">
      <v-row class="fill-height" align="center" justify="center">
        <v-img
          :src="slide.image_url"
          :aspect-ratio="$vuetify.breakpoint.mdAndUp ? 3 : $vuetify.breakpoint.sm ? 1.6:1"
        ></v-img>
      </v-row>
    </v-carousel-item>
  </v-carousel>
</template>

<script>
export default {
  props: ['slides'],
  data: () => ({
    // slides: ["First", "Second", "Third"]
  })
};
</script>

<style></style>
